import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarehouse,
  faDesktop,
  faDatabase,
  faBuilding,
  faMicrochip,
  faUser,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { HashLink } from 'react-router-hash-link';
import { Nav } from 'react-bootstrap';
import { Routes, pageKey } from '../routes';

const SideMenuItem = ({
  activePage,
  pageName,
  pagePath,
  icon,
  title,
}: {
  activePage?: string;
  pageName: string;
  pagePath: string;
  icon: IconDefinition;
  title: string;
}) => (
  <li className={clsx('nav-item', activePage === pageName ? 'active' : '')}>
    <Nav.Link
      className="d-flex justify-content-center py-3"
      as={HashLink}
      to={pagePath}
      title={title}
    >
      <FontAwesomeIcon size="lg" icon={icon} />
    </Nav.Link>
  </li>
);

const Navbar = ({ activePage }: { activePage?: string }) => {
  return (
    <div className="position-sticky">
      <ul className="nav flex-column py-2">
        {/* == Home Page == */}
        <SideMenuItem
          activePage={activePage}
          pageName={pageKey.HOME}
          pagePath={Routes.HomeScreen.path}
          icon={faWarehouse}
          title="Home page"
        />
        {/* == Job status monitoring == */}
        <SideMenuItem
          activePage={activePage}
          pageName={pageKey.JOB}
          pagePath={Routes.JobStatusTracking.path}
          icon={faDesktop}
          title="Jobs"
        />
        {/* == Company Management == */}
        <SideMenuItem
          activePage={activePage}
          pageName={pageKey.COMPANY}
          pagePath={Routes.CompanyProfiles.path}
          icon={faBuilding}
          title="Company Admin"
        />
        {/* == User Management == */}
        <SideMenuItem
          activePage={activePage}
          pageName={pageKey.USERS}
          pagePath={Routes.UserManagment.path}
          icon={faUser}
          title="User Admin"
        />
        {/* == Item catelogue Management == */}
        <SideMenuItem
          activePage={activePage}
          pageName={pageKey.CATALOGUE}
          pagePath={Routes.ItemCatalogue.path}
          icon={faDatabase}
          title="Items"
        />
        {/* == AI Modules Management == @2025/04/23 */}
        <SideMenuItem
          activePage={activePage}
          pageName={pageKey.AIMODULES}
          pagePath={Routes.AIModules.path}
          icon={faMicrochip}
          title="AI Modules Management"
        />
      </ul>
    </div>
  );
};

export default Navbar;
